import { i18n } from 'fishx';

export const ComplicatedServiceType = [300, 319, 185, 288, 797, 798, 799, 918];

export const getExpandFormItems = params => {
  const { serviceType, maxIPNum } = params;
  if (serviceType === 300 || serviceType === 319) {
    return [{
      label: 'Hotline Number',
      name: 'EXP_HOTLINE_NBR',
      type: 'input',
      options: { rules: [{ required: true }], initialValue: '' },
      formItemCompProps: {},
    }];
  }
  if (serviceType === 798 || serviceType === 799) {
    return [{
      label: 'IP order quantity',
      name: 'EXP_IP_NUM',
      type: 'inputNumber',
      options: { rules: [{ required: true }], initialValue: '' },
      formItemCompProps: {
        max: maxIPNum,
      },
    }];
  }
  if (serviceType === 918) {
    return [{
      label: 'Telemarketing Number',
      name: 'BSNL_TELEMARKETING_NBR',
      type: 'input',
      options: { rules: [{ required: true }], initialValue: '' },
      formItemCompProps: {},
    }];
  }
  return [];
};

export const getEmailFormItems = (defaultInfo = {}, index, onChange) => ([{
  label: i18n('EMAIL_ID'),
  name: `email_${defaultInfo.key}`,
  type: 'input',
  options: {
    rules: [{
      required: true,
      message: i18n('FORM_MESSAGE_ERROR_REQUIRED', { label: i18n('EMAIL_ID') }),
    }, {
      type: 'email',
      message: i18n('VALID_EMAIL'),
    }],
    initialValue: defaultInfo.email,
  },
  formItemCompProps: {
    onChange: e => onChange(e, index),
  },
}]);
